import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faLink} from '@netx/core-icons';
import {canCreateShareLinkFromAsset} from '../enablers';
import {AssetActionLabel} from '../locales';
import {type IAsset} from '../schema';
import {ASSET_EVENT} from './constants';

export const assetActionShareLinkIcon = faLink;

/**
 * Asset share link
 * @param params
 * @returns Action
 */
export const assetActionShareLink = (
	asset?: IAsset,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'asset-share-link',
	cb: () => dispatcher.trigger(ASSET_EVENT.SHARE_LINK, asset),
	enableTest: () => canCreateShareLinkFromAsset(asset),
	icon: assetActionShareLinkIcon,
	get label() {
		return AssetActionLabel.SHARE_LINK;
	},
	...params,
});

export default assetActionShareLink;
